/* eslint-disable max-lines-per-function, max-statements, complexity, max-lines */
/**
 * Default values for news critics state
 */
const DEFAULT_LIST = [];
const DEFAULT_IS_ADD_HOME_VIDEO = true;
const DEFAULT_IS_ONLY_NEW = true;
const DEFAULT_IS_ONLY_PRESENT = false;
const DEFAULT_IS_SHOW_FLAGGED = false;
const DEFAULT_IS_TOGGLE_FLAGGED_LOADING = false;
const DEFAULT_NEXT_CURSOR = null;
/**
 * DEFAULT_SELECTED
 *
 * Selected News
 */
const DEFAULT_SELECTED = {
    id: "",
    isPreviewLoading: false,
    isPreviewValid: false,
    url: ""
};
/**
 * DEFAULT_HOME_VIDEO_REVIEW
 *
 * Default News to create
 */
export const DEFAULT_NEWS = {
    authorId: null,
    images: undefined,
    isAddHomeVideo: DEFAULT_IS_ADD_HOME_VIDEO,
    isBluRay: true,
    isPublished: false,
    isUHD: true,
    name: "",
    sourcesIds: []
};
/**
 * DEFAULT_NEWS_SOURCES_IDS_SERVICE_MAP
 *
 * Default map of news sources ids to service names
 */
const DEFAULT_NEWS_SOURCES_IDS_SERVICE_MAP = {
    avNirvana: "",
    bluRay: "",
    hidefDigest: "",
    whySoBlu: ""
};
/**
 * initalNewsCriticsState
 *
 * Initial state for each news critics service
 */
const initalNewsCriticsState = {
    display: DEFAULT_LIST,
    isOnlyNew: DEFAULT_IS_ONLY_NEW,
    isOnlyPresent: DEFAULT_IS_ONLY_PRESENT,
    isShowFlagged: DEFAULT_IS_SHOW_FLAGGED,
    nextCursor: DEFAULT_NEXT_CURSOR,
    selected: DEFAULT_SELECTED
};
/**
 * DEFAULT_NEWS_SINGLE_SOURCE_STATE
 *
 * @description
 * Initial state for single news source
 */
const DEFAULT_NEWS_SINGLE_SOURCE_STATE = {
    id: "",
    labelId: "",
    outletId: "",
    url: ""
};
/**
 * initialState
 *
 * Initial state for all newss critics
 */
export const initialState = {
    avNirvana: initalNewsCriticsState,
    bluRay: initalNewsCriticsState,
    hidefDigest: initalNewsCriticsState,
    isToggleFlaggedLoading: DEFAULT_IS_TOGGLE_FLAGGED_LOADING,
    news: DEFAULT_NEWS,
    newsSourcesIdsServiceMap: DEFAULT_NEWS_SOURCES_IDS_SERVICE_MAP,
    singleSource: DEFAULT_NEWS_SINGLE_SOURCE_STATE,
    whySoBlu: initalNewsCriticsState
};
/**
 *  Action Types
 */
export const RESET_SELECTED_NEWS_CRITICS = "RESET_SELECTED_NEWS_CRITICS";
export const RESET_SELECTED_NEWS_CRITICS_LIST = "RESET_SELECTED_NEWS_CRITICS_LIST";
export const SET_ADDITIONAL_INSTRUCTIONS = "SET_ADDITIONAL_INSTRUCTIONS";
export const SET_AUTHOR_ID = "SET_AUTHOR_ID";
export const SET_HOME_VIDEO_ID = "SET_HOME_VIDEO_ID";
export const SET_IMAGES = "SET_IMAGES";
export const SET_SCREENSHOTS = "SET_SCREENSHOTS";
export const SET_IS_ADD_HOME_VIDEO = "SET_IS_ADD_HOME_VIDEO";
export const SET_IS_ONLY_NEW = "SET_IS_ONLY_NEW";
export const SET_IS_ONLY_PRESENT = "SET_IS_ONLY_PRESENT";
export const SET_IS_SHOW_FLAGGED = "SET_IS_SHOW_FLAGGED";
export const SET_IS_TOGGLE_FLAGGED_LOADING = "SET_IS_TOGGLE_FLAGGED_LOADING";
export const SET_IS_UHD = "SET_IS_UHD";
export const SET_LIST = "SET_LIST";
export const SET_NAME = "SET_NAME";
export const SET_NEXT_CURSOR = "SET_NEXT_CURSOR";
export const SET_IMDB_ID = "SET_IMDB_ID";
export const SET_TMDB_SELECTED_IMDB_ID = "SET_TMDB_SELECTED_IMDB_ID";
export const SET_TMDB_SELECTED_ID = "SET_TMDB_SELECTED_ID";
export const SET_OVERRIDES = "SET_OVERRIDES";
export const SET_RELEASE_DATE = "SET_RELEASE_DATE";
export const SET_SELECTED_ID = "SET_SELECTED_ID";
export const SET_SELECTED_IS_PREVIEW_LOADING = "SET_SELECTED_IS_PREVIEW_LOADING";
export const SET_SELECTED_IS_PREVIEW_VALID = "SET_SELECTED_IS_PREVIEW_VALID";
export const SET_SELECTED_IS_NEWS_CRITICS_CREATED = "SET_SELECTED_IS_NEWS_CRITICS_CREATED";
export const SET_SELECTED_NEWS = "SET_SELECTED_NEWS";
export const SET_SELECTED_SINGLE_SOURCE = "SET_SELECTED_SINGLE_SOURCE";
/**
 * getSelectedIdAndUrl
 *
 * @description
 * Get selected id and url from state
 * @param {NewsCriticsState} state - Current state of all reviews
 * @param {string} selected - Selected review id
 * @returns {{ id: string; url: string }} - Object containing id and url
 *
 */
const getSelectedIdAndUrl = (state, selected) => {
    const result = state.display.find(({ id }) => id === selected);
    if (!result) {
        return { id: "", url: "" };
    }
    return {
        id: result.id,
        url: result.url
    };
};
/**
 * reducer
 *
 *  @description
 *  Reducer for all news critics
 *  @param {AllNewsCriticsState} state - Current state of all news critics
 *  @param {NewsCriticsAction} action - Action to be performed
 *  @returns {AllNewsCriticsState} - New state of all news critics
 *
 */
const reducer = (
// eslint-disable-next-line default-param-last
state = initialState, action) => {
    switch (action.type) {
        case RESET_SELECTED_NEWS_CRITICS: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: DEFAULT_SELECTED
                }
            };
        }
        case RESET_SELECTED_NEWS_CRITICS_LIST: {
            return {
                avNirvana: { ...state.avNirvana, selected: DEFAULT_SELECTED },
                bluRay: { ...state.bluRay, selected: DEFAULT_SELECTED },
                hidefDigest: { ...state.hidefDigest, selected: DEFAULT_SELECTED },
                isToggleFlaggedLoading: state.isToggleFlaggedLoading,
                news: DEFAULT_NEWS,
                newsSourcesIdsServiceMap: DEFAULT_NEWS_SOURCES_IDS_SERVICE_MAP,
                singleSource: DEFAULT_NEWS_SINGLE_SOURCE_STATE,
                tmdbSelectedImdbId: undefined,
                tmdbSelectedId: undefined,
                whySoBlu: { ...state.whySoBlu, selected: DEFAULT_SELECTED }
            };
        }
        case SET_ADDITIONAL_INSTRUCTIONS: {
            return {
                ...state,
                news: {
                    ...state.news,
                    additionalInstructions: action.payload.additionalInstructions
                }
            };
        }
        case SET_AUTHOR_ID: {
            return {
                ...state,
                news: {
                    ...state.news,
                    authorId: action.payload.authorId
                }
            };
        }
        case SET_HOME_VIDEO_ID: {
            return {
                ...state,
                news: {
                    ...state.news,
                    homeVideoId: action.payload.homeVideoId
                }
            };
        }
        case SET_IMAGES: {
            return {
                ...state,
                news: {
                    ...state.news,
                    images: action.payload.images
                }
            };
        }
        case SET_SCREENSHOTS: {
            return {
                ...state,
                news: {
                    ...state.news,
                    screenshots: action.payload.screenshots
                }
            };
        }
        case SET_IS_ADD_HOME_VIDEO: {
            return {
                ...state,
                news: {
                    ...state.news,
                    isAddHomeVideo: action.payload.isAddHomeVideo
                }
            };
        }
        case SET_IS_ONLY_NEW: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isOnlyNew: action.payload.isOnlyNew,
                    isOnlyPresent: action.payload.isOnlyNew
                        ? false
                        : state[action.payload.service].isOnlyPresent
                }
            };
        }
        case SET_IS_ONLY_PRESENT: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isOnlyNew: action.payload.isOnlyPresent
                        ? false
                        : state[action.payload.service].isOnlyNew,
                    isOnlyPresent: action.payload.isOnlyPresent
                }
            };
        }
        case SET_IS_SHOW_FLAGGED: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isShowFlagged: action.payload.isShowFlagged
                }
            };
        }
        case SET_IS_TOGGLE_FLAGGED_LOADING: {
            return {
                ...state,
                isToggleFlaggedLoading: action.payload.isToggleFlaggedLoading
            };
        }
        case SET_IS_UHD: {
            return {
                ...state,
                news: {
                    ...state.news,
                    isUHD: action.payload.isUHD
                }
            };
        }
        case SET_LIST: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    display: action.payload.list
                }
            };
        }
        case SET_NAME: {
            return {
                ...state,
                news: {
                    ...state.news,
                    name: action.payload.name
                }
            };
        }
        case SET_NEXT_CURSOR: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    nextCursor: action.payload.nextCursor
                }
            };
        }
        case SET_IMDB_ID: {
            return {
                ...state,
                news: {
                    ...state.news,
                    IMDbId: action.payload.IMDbId
                }
            };
        }
        case SET_TMDB_SELECTED_IMDB_ID: {
            return {
                ...state,
                tmdbSelectedImdbId: action.payload.tmdbSelectedImdbId
            };
        }
        case SET_TMDB_SELECTED_ID: {
            return {
                ...state,
                tmdbSelectedId: action.payload.tmdbSelectedId
            };
        }
        case SET_OVERRIDES: {
            return {
                ...state,
                [`${action.payload.serviceName}`]: {
                    ...state[action.payload.serviceName],
                    selected: {
                        ...state[action.payload.serviceName].selected,
                        overrides: {
                            ...state[action.payload.serviceName].selected.overrides,
                            ...action.payload.overrides
                        }
                    }
                }
            };
        }
        case SET_RELEASE_DATE: {
            return {
                ...state,
                news: {
                    ...state.news,
                    releaseDate: action.payload.releaseDate
                }
            };
        }
        case SET_SELECTED_ID: {
            const { url } = getSelectedIdAndUrl(state[action.payload.service], action.payload.selected);
            // Get source id to reset from map by service name
            const sourceIdToReset = state.newsSourcesIdsServiceMap[action.payload.service];
            return {
                ...state,
                news: {
                    ...state.news,
                    // Always reset selected source id
                    sourcesIds: state.news.sourcesIds?.filter((sourceId) => sourceId !== sourceIdToReset)
                },
                // Add selected service to state
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        id: action.payload.selected,
                        isPreviewValid: false,
                        url
                    }
                }
            };
        }
        case SET_SELECTED_IS_PREVIEW_LOADING: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        isPreviewLoading: action.payload.isPreviewLoading
                    }
                }
            };
        }
        case SET_SELECTED_IS_PREVIEW_VALID: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        isPreviewValid: action.payload.isPreviewValid
                    }
                }
            };
        }
        case SET_SELECTED_IS_NEWS_CRITICS_CREATED: {
            let sourceIdToReset;
            if (action.payload.service) {
                sourceIdToReset = state.newsSourcesIdsServiceMap[action.payload.service];
            }
            if (state.singleSource.id) {
                sourceIdToReset = state.singleSource.id;
            }
            return {
                ...state,
                news: {
                    ...state.news,
                    // Always reset selected source id by service name before we
                    // add a new one to the same service
                    sourcesIds: [
                        ...(state.news.sourcesIds?.filter((sourceId) => sourceId !== sourceIdToReset) ?? []),
                        action.payload.id
                    ]
                },
                newsSourcesIdsServiceMap: {
                    ...state.newsSourcesIdsServiceMap,
                    // Set new source id to map by service name
                    // if we have a service name
                    ...(action.payload.service
                        ? { [action.payload.service]: action.payload.id }
                        : {})
                }
            };
        }
        case SET_SELECTED_NEWS: {
            return {
                ...state,
                news: {
                    ...state.news,
                    isPublished: action.payload.isPublished,
                    // This will work if we always make sure we reset news before we select
                    // a new news we wanna edit
                    sourcesIds: [...(state.news.sourcesIds ?? []), action.payload.id]
                },
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        isPreviewValid: false,
                        url: action.payload.url
                    }
                }
            };
        }
        case SET_SELECTED_SINGLE_SOURCE: {
            return {
                ...state,
                singleSource: {
                    id: action.payload.id,
                    labelId: action.payload.labelId,
                    outletId: action.payload.outletId,
                    url: action.payload.url
                }
            };
        }
        default: {
            return state;
        }
    }
};
export default reducer;
